import React from "react";
import ShoppingCartImageSvg from "./ShoppingCartImageSvg";

const ShoppingCartLight = () => <ShoppingCartImageSvg />;
export default ShoppingCartLight;
